import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getAllCountryListFailure, getAllCountryListSuccess } from '../../actions/publicActions/getAllCountryActions';
import store from '../../configStore';

function* getAllCountryList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllCountry,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_COUNTRIES_SUCCESS status :", response.data.status);
        console.log("GET_ALL_COUNTRIES_SUCCESS data :", response.data.response);
        console.log("GET_ALL_COUNTRIES_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllCountryListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_COUNTRIES_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_COUNTRIES_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_COUNTRIES_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllCountryListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllCountryListSaga() {
    yield takeLatest(actionTypes.GET_ALL_COUNTRIES_REQUEST, getAllCountryList);
}

export default getAllCountryListSaga;
